import React from "react";

//comp
import { PopularProducts } from "../index";
//ui
import Grid from "@material-ui/core/Grid";

const HelperSlider = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <PopularProducts itemOnRow={1} size={9} />
      </Grid>
    </Grid>
  );
};

export default HelperSlider;
